// Statistics Service
// Handles all statistics and analytics API calls

import authService from './Auth.services.js';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://the-live-cure-be.vercel.app/api';

class StatsService {
  // Dashboard Statistics
  async getDashboardStats() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/stats/dashboard`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch dashboard statistics');
      }

      const data = await response.json();
      return data.result || data.stats;
    } catch (error) {
      console.error('Get dashboard stats error:', error);
      throw error;
    }
  }

  // Doctor Statistics
  async getDoctorStats() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/stats/doctors`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch doctor statistics');
      }

      const data = await response.json();
      return data.result || data.stats;
    } catch (error) {
      console.error('Get doctor stats error:', error);
      throw error;
    }
  }

  // Booking Statistics
  async getBookingStats() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/stats/bookings`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch booking statistics');
      }

      const data = await response.json();
      return data.result || data.stats;
    } catch (error) {
      console.error('Get booking stats error:', error);
      throw error;
    }
  }

  // Clinic Statistics
  async getClinicStats() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/stats/clinics`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch clinic statistics');
      }

      const data = await response.json();
      return data.result || data.stats;
    } catch (error) {
      console.error('Get clinic stats error:', error);
      throw error;
    }
  }

  // Appointment Statistics
  async getAppointmentStats() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/stats/appointments`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch appointment statistics');
      }

      const data = await response.json();
      return data.result || data.stats;
    } catch (error) {
      console.error('Get appointment stats error:', error);
      throw error;
    }
  }

  // Specialty Statistics
  async getSpecialtyStats() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/stats/specialties`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch specialty statistics');
      }

      const data = await response.json();
      return data.result || data.stats;
    } catch (error) {
      console.error('Get specialty stats error:', error);
      throw error;
    }
  }

  // Monthly Data
  async getMonthlyData() {
    try {
      const token = authService.getToken();
      
      if (!token) {
        throw new Error('No authentication token');
      }

      const response = await fetch(`${API_BASE_URL}/stats/monthly`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch monthly data');
      }

      const data = await response.json();
      return data.result || data.data;
    } catch (error) {
      console.error('Get monthly data error:', error);
      throw error;
    }
  }
}

// Create and export a singleton instance
const statsService = new StatsService();
export default statsService;
